export const FetchQueue = (function () {
	'use strict';

	let queue = [],
		running = false;

	function addRequest(url, request, maxAttempts, delay, fixed) {
		return new Promise(function (resolve, reject) {
			queue.push({
				maxAttempts: maxAttempts || 1,
				delay: delay || 1000,
				fixed: fixed === false,
				request: request,
				url: url,
				retry: 0,
				resolve: resolve,
				reject: reject
			});

			processQueue();
		});
	}

	function processQueue() {
		if (running) {
			return;
		}

		let next = queue.shift();
		if (!next) {
			return;
		}

		running = true;

		try {
			fetch(next.url, next.request).then(next.resolve).catch(next.reject);
		} catch (exception) {
			next.reject(exception);
		} finally {
			running = false;
			processQueue();
		}
	}

	return {
		addRequest: addRequest
	};
})();
